/**
 * What a menu's search compares — the words a person types, against a row's
 * label and the line under it.
 *
 * Vladimir, 2026-09-23, once every Asana project was finally listed: *"make
 * sure that search works correctly"*. A plain substring test failed in ways a
 * person reads as "it is not there": "pilot alpha" did not find "Alpha
 * pilot", a typed ' did not find a ’ in a name, and ё did not find е.
 */

/** Text folded to what matters for finding it: case, accents, quote and dash shapes, spacing. */
export function fold(text: string): string {
  return (
    text
      // é → e, ё → е: the mark is not what anybody searches by.
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .toLowerCase()
      .replace(/[‘’‚‛′`´]/g, "'")
      .replace(/[“”„‟″]/g, '"')
      .replace(/[‐‑‒–—―−]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
  );
}

/** Every word of the query somewhere in the texts, in any order. An empty query matches all. */
export function matches(query: string, ...texts: Array<string | null | undefined>): boolean {
  const words = fold(query).split(' ').filter(Boolean);
  if (words.length === 0) return true;
  const haystack = fold(texts.filter((t): t is string => !!t).join(' '));
  return words.every((word) => haystack.includes(word));
}
